export default __webpack_public_path__ + "static/media/z050mi0a.4694211c.mp3";